import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { QuestionRecord } from 'src/app/model/question-record';
import { QuestionsService } from 'src/app/services/questions.service';

@Component({
  selector: 'app-question-number',
  templateUrl: './question-number.component.html',
  styleUrl: './question-number.component.scss',
})
export class QuestionNumberComponent implements OnInit{
  selectedQuestionNumber: number;
  questionRecord: QuestionRecord[];
  changeQuestionRecordSubscription$: Subscription;
  selectedQuestionNumberSubscription$: Subscription;

  constructor(private questionsService: QuestionsService) {}

  ngOnInit(): void {
    this.navigateQuestion(0);

    this.questionRecord = this.questionsService.questionRecords;
    this.changeQuestionRecordSubscription$ = this.questionsService
    .changeQuestionRecord$
    .subscribe({
      next: () => {
        this.questionRecord = this.questionsService.questionRecords;
      }
    });

    this.selectedQuestionNumber = this.questionsService.selectedQuestionNumber;
    this.selectedQuestionNumberSubscription$ = this.questionsService
    .selectedQuestionNumber$
    .subscribe({
      next: (value) => {
        this.selectedQuestionNumber = value;
      }
    });
  }

  navigateQuestion(questionNumber: number): void {
    this.questionsService.navigateQuestion(questionNumber);
  }
}
